import { NumberInput } from '@frontend/components/basic-forms';
import { AsyncComponent } from '@frontend/components/common';
import { ActionModal } from '@frontend/components/modal';
import { CommonMessage, useLocale } from '@frontend/lang';
import { defaultMapWithAttributes } from '@frontend/product/badge';
import { ProductType } from '@frontend/product/types';
import React from 'react';

import { LinkKitItemsModalProps, useLinkKitItemsModal } from './link-kit-items-modal.controller';

const MultiKitProductSelect = React.lazy(() => import('@frontend/product/select').then((module) => ({ default: module.MultiKitProductSelect })));

export type { LinkKitItemsModalProps } from './link-kit-items-modal.controller';

export const LinkKitItemsModal = (props: LinkKitItemsModalProps) => {
    const viewProps = useLinkKitItemsModal(props);
    const { locale } = useLocale();

    return (
        <ActionModal
            title={CommonMessage.BUTTONS.LINK}
            confirm={{
                onConfirm: viewProps.onSubmit,
                label: CommonMessage.BUTTONS.ADD(),
                disabled: viewProps.isSubmitting || viewProps.linkProducts.length === 0,
                isLoading: viewProps.isSubmitting
            }}
            cancel={{ onCancel: viewProps.onCancel, label: CommonMessage.BUTTONS.CANCEL }}>
            <div className='flex w-full flex-col gap-4'>
                <AsyncComponent>
                    <MultiKitProductSelect
                        label={CommonMessage.OBJECTS.PRODUCT.PLURAL}
                        value={viewProps.linkProducts.map((p) => p.id)}
                        onChangeObject={viewProps.setLinkProducts}
                        queryParams={{
                            type: [ProductType.EQUIPMENT, ProductType.CONSUMABLE]
                        }}
                        excludeProductId={props.product.id}
                    />
                </AsyncComponent>
                {viewProps.linkProducts.length > 0 && (
                    <div className='flex flex-col gap-2'>
                        {viewProps.linkProducts.map((product) => (
                            <div
                                key={product.id}
                                className='flex items-end gap-2'>
                                <div className='text-foreground-default grow self-center text-sm font-medium'>
                                    {defaultMapWithAttributes(product, locale, ['ean', 'sku'])}
                                </div>
                                <div className='w-32'>
                                    <NumberInput
                                        id={`link-kit-quantity-${product.id}`}
                                        label={CommonMessage.OBJECTS.COMMON_FIELDS.QUANTITY}
                                        value={viewProps.quantities[product.id] ?? 1}
                                        min={1}
                                        onChange={(v) => viewProps.setQuantity(product.id, v)}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </ActionModal>
    );
};
